import { useRef, useCallback } from "react"

export const useDebounce = (func: (...args: any[]) => void, wait: number) => {
  const timeout = useRef<any>()

  return useCallback(
    (...args) => {
      const callback = () => {
        clearTimeout(timeout.current)
        func(...args)
      }

      clearTimeout(timeout.current)
      timeout.current = setTimeout(callback, wait)
    },
    [func, wait],
  )
}
